import { api } from './axios'
import type { ValoresParceiros, MatriculaResult } from '@/types'

export async function getValoresParceiros(params: {
  curso: number
  cnpjParceiro: string
  ufParceiro: string
  ufDestino: string
}) {
  const response = await api.get<ValoresParceiros>('/matriculas/valores-parceiros', { params })
  return response.data
}

export async function getCamposFormulario(uf: string, curso: number) {
  const response = await api.get<string[]>('/matriculas/campos-formulario', {
    params: { uf, curso },
  })
  return response.data
}

export interface ValidarAlunoData {
  nome: string
  dataNascimento: string
  cpf: string
  email: string
  telefone: string
  uf: string
  municipio?: string
  cursoId: number
  cnh?: string
  categoriaCnh?: string
  dataPrimeiraHabilitacao?: string
  rg?: string
  renach?: string
}

export async function validarAluno(data: ValidarAlunoData) {
  const response = await api.post<{
    success: boolean
    errorType?: string
    errorMessage?: string
  }>('/matriculas/validar', data)
  return response.data
}

export interface CreateMatriculaData {
  nome: string
  dataNascimento: string
  cpf: string
  email: string
  telefone: string
  cnh?: string
  categoriaCnh?: string
  dataPrimeiraHabilitacao?: string
  rg?: string
  cursoId: number
  valor: number
  cnpjParceiro: string
  uf: string
  ufDestino: string
  ufParceiro: string
  municipio?: string
  renach?: string
}

export async function createMatricula(data: CreateMatriculaData): Promise<MatriculaResult> {
  const response = await api.post<MatriculaResult>('/matriculas', data)
  return response.data
}

export async function reemitirCobranca(matriculaId: number) {
  const response = await api.post(`/matriculas/reemitir-cobranca/${matriculaId}`)
  return response.data
}

/** O backend grava o valor recebido, não inverte o atual — quem chama manda o estado desejado. */
export async function definirPermissaoCertificado(
  matriculaId: number,
  permiteEmissaoCertificado: boolean
) {
  const response = await api.put('/matriculas/permissao-certificado', {
    matriculaId,
    permiteEmissaoCertificado,
  })
  return response.data
}

export async function createPixCharge(matriculaId: number) {
  const response = await api.post(`/matriculas/pix/${matriculaId}`)
  return response.data
}

export interface CobrancaAgregadaResult {
  id: number
  valor: number
  infoPix: { txid: string; pix: string }
}

// Groups several matrículas' Pagamentos under one umbrella charge settled by a single pagamentoId.
// `valor` is the price charged for the bundle — omit it to charge exactly New Driver's cost; pass a
// higher one to include the parceiro's own margin. Paying any individual matrícula voids the
// aggregate. See createCobrancaAgregada (backend).
export async function createCobrancaAgregada(matriculaIds: number[], valor?: number) {
  const response = await api.post<CobrancaAgregadaResult>('/parceiros/cobranca-agregada', {
    matriculaIds,
    valor,
  })
  return response.data
}
